export enum BrandsEnum {
  None = "",
  Audi = "audi",
  Bmw = "bmw",
  BmwMO = "bmwmo",
  Dacia = "dacia",
  Ford = "ford",
  IfRullaVidare = "ifrullavidare",
  IfRullaVidareMO = "ifrullavidaremo",
  Kia = "kia",
  Cupra = "cupra",
  Mercedes = "mercedes",
  Mini = "mini",
  Nissan = "nissan",
  NissanNo = "nissanno",
  NissanNoMO = "nissannomo",
  Opel = "opel",
  Polestar = "polestar",
  PolestarMO = "polestarmo",
  PolestarForetag = "polestarforetag",
  PolestarForetagMO = "polestarforetagmo",
  Porsche = "porsche",
  Renault = "renault",
  RenaultForetag = "renaultforetag",
  MG = "mg",
  Saab = "saab",
  Seat = "seat",
  Skoda = "skoda",
  Volkswagen = "volkswagen",
  Volvia = "volvia",
  VolviaNo = "volviano",
  VolviaForetag = "volviaforetag",
  Volkswagentransportbilar = "volkswagentransportbilar",
}

export enum BrandAreaEnum {
  None = "",
  IMF = "IMF",
  VRF = "VRF",
  NO = "NO",
}

export function GetBrandArea(brand: BrandsEnum): BrandAreaEnum {
  switch (brand) {
    case BrandsEnum.Volvia:
    case BrandsEnum.VolviaForetag:
    case BrandsEnum.Renault:
    case BrandsEnum.Dacia:
    case BrandsEnum.Polestar:
    case BrandsEnum.PolestarMO:
    case BrandsEnum.PolestarForetag:
    case BrandsEnum.PolestarForetagMO:
      return BrandAreaEnum.VRF;
    case BrandsEnum.Audi:
    case BrandsEnum.Bmw:
    case BrandsEnum.BmwMO:
    case BrandsEnum.Ford:
    case BrandsEnum.IfRullaVidare:
    case BrandsEnum.IfRullaVidareMO:
    case BrandsEnum.Kia:
    case BrandsEnum.Cupra:
    case BrandsEnum.Mercedes:
    case BrandsEnum.Mini:
    case BrandsEnum.Nissan:
    case BrandsEnum.Opel:
    case BrandsEnum.Porsche:
    case BrandsEnum.Saab:
    case BrandsEnum.Seat:
    case BrandsEnum.Skoda:
    case BrandsEnum.Volkswagen:
    case BrandsEnum.Volkswagentransportbilar:
    case BrandsEnum.MG:
      return BrandAreaEnum.IMF;
    case BrandsEnum.NissanNo:
    case BrandsEnum.NissanNoMO:
    case BrandsEnum.VolviaNo:
      return BrandAreaEnum.NO;
    default:
      throw new Error(`Can not match 'BrandArea' for brand '${brand}'!`);
  }
}

export function IsCommercialBrand(brand?: BrandsEnum): boolean {
  if (brand) {
    if (brand === BrandsEnum.VolviaForetag || brand === BrandsEnum.PolestarForetag || brand === BrandsEnum.PolestarForetagMO ) {
      return true;
    }
  }
  return false;
}
